"use client";

import dynamic from "next/dynamic";

// Same Firebase-deferral reasoning as GetStartedButtonLazy. ProfileMenu
// itself renders null until a signed-in user is confirmed, so a null
// loading state matches its own default exactly.
const ProfileMenu = dynamic(() => import("./ProfileMenu"), { ssr: false });

export default ProfileMenu;
